import React, { useRef } from 'react';
import { usePopup } from '../../context/PopupContext';
import { connect } from 'react-redux';

const AlertPopup = (props) => {
    const {boxContent, close, status, rightCallbackAction, leftCallbackAction, data } =  usePopup();

    return (<>
        {status('alertbox') && <><div className="transparent-popup-bg"></div>
        <div className="custom-skip-popup">
            <div className="close-btn-icon">
                <button
                    className="close-icon test-close"
                    onClick={close}>Close</button>
            </div>
            <div className="content-box">
                <h4>{boxContent.heading}</h4>
                <p>{boxContent.content}</p>
                <div className="button-area">
                    <button className="skip" onClick={rightCallbackAction}>{boxContent.confirmButtonText}</button>
                </div>
            </div>
        </div></>}
    </>)
}

export default connect(state => state)(AlertPopup);

